import type { components } from "@/api-schema";
import { getBrandDatIdentifier } from "@/modules/masterdata/brand/brand-identifiers";
import type { FilterOption } from "../../_types";

export const BRAND_DAT_ID_NOT_SET = "IS_NULL";

export function buildBrandDatIdFilterOptions(
  brands: readonly Pick<components["schemas"]["Brand"], "brandIdentifiers">[] = [],
  selectedValues: readonly string[] = [],
  searchTerm = "",
): FilterOption[] {
  const normalizedSearchTerm = searchTerm.trim().toLowerCase();
  const matchingDatIds = brands
    .map(getBrandDatIdentifier)
    .filter((datId) => !normalizedSearchTerm || datId?.toLowerCase().includes(normalizedSearchTerm));
  const datIds = new Set([...matchingDatIds, ...selectedValues]);

  return [
    { id: BRAND_DAT_ID_NOT_SET, name: "common:NotSet" },
    ...Array.from(datIds)
      .filter((datId): datId is string => !!datId?.trim() && datId !== BRAND_DAT_ID_NOT_SET)
      .map((datId) => ({ id: datId, name: datId })),
  ];
}
